import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { HomeLayout, PolicyConsentsLayout } from '..';
import InlineSpinner from '../../../common/components/misc/InlineSpinner';

import MainLayoutContainer, { MainLayoutContainerProps } from './containers/MainLayoutContainer';
import './Main.scss';
import './MainLayout.scss';

const MainLayout: React.FC<MainLayoutContainerProps> = (containerProps) => {
    return (
        <MainLayoutContainer {...containerProps}>
            {(props) => {
                if (props.isReadyToRender) {
                    return (
                        <React.Fragment>
                            <Switch>
                                <Route exact path={[`${props.config.BaseURL}/policyconsents`, `${props.config.AlternativeBaseURL}/policyconsents`]} component={PolicyConsentsLayout} />
                                <Route path={[props.config.BaseURL, props.config.AlternativeBaseURL]} component={HomeLayout} />
                            </Switch>
                        </React.Fragment>
                    );
                }
                return (
                    <InlineSpinner size={'100px'} />
                );
            }}
        </MainLayoutContainer>
    );
};

export default MainLayout;
